import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";

import { ReactComponent as Stockhub } from '../../../../styles/svg/stockhub.svg';

import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Text from "../../../theme/text/Text";
import { useNavigate } from "react-router-dom";

const SystemNotifcationComponent = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    const navigate = useNavigate();
    
    return(
        <Box
            onClick={() => {
                if(props.onClick) {
                    props.onClick();
                }
                if(props.data?.url) {
                    navigate(props.data.url);
                }
            }}
            sx={{
                cursor:"pointer",
                px:1.5,
                display:"flex",
                gap:2,
                width:1,
                borderRadius:4,
                py:1.5,
                transition:"200ms",
                "&:hover" : {
                    background:colors.grey[100],
                    borderBottomColor:'orange'
                }
            }}
        >
            <Box
                sx={{
                    height:32,
                    width:32,
                    flexShrink:0,
                    display:'flex',
                    alignItems:"center",
                    justifyContent:'center',
                    background:theme.palette.mode === "dark" ? colors.grey[100] : colors.grey[100],
                    color:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[400],
                    borderRadius:3,
                    overflow:'hidden',
                }}
            >
                <Stockhub/>
            </Box>
            <Box
                sx={{
                    flex:1,
                    display:'flex',
                    flexDirection:'column'
                }}
            >
                <Text bold>{props.title}</Text>
                <Text >{props.body}</Text>
            </Box>
        </Box>
    )
}

export default SystemNotifcationComponent;